import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import AppImage from '../../components/AppImage'; // Import AppImage

const Footer = ({
  variant = 'full',
  className = '',
  ...props
}) => {
  // Current year for copyright
  const currentYear = new Date().getFullYear();
  
  // Footer navigation items
  const footerNavigation = {
    products: [
      { name: 'Products', href: '/products' },
      { name: 'Skin Passport', href: '/skin-passport' },
      { name: 'Recomendations', href: '/recommendations' },
      { name: 'Learn More', href: '/learn-more' },
      // { name: 'API', href: '/api-documentation' },
      // { name: 'For business', href: '/for-business' }
    ],
    account: [
      { name: 'My Account', href: '/user-account-page' },
      { name: 'API', href: '/api-documentation' },
      // { name: 'Settings', href: '/user-account-page/settings' },
      { name: 'Prices', href: '/prices' },
      // { name: 'Wishlist', href: '/user-account-page/wishlist' },
      
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Careers', href: '/jobs' },
      { name: 'Our team', href: '/our-team' },
      // { name: 'Sustainability', href: '/sustainability' }
    ],
    legal: [
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Cookie Policy', href: '/cookies' },
      { name: 'Accessibility', href: '/accessibility' }
    ],
    support: [
      { name: 'Help Center', href: '/help' },
      { name: 'Contact Us', href: '/for-business' },
      { name: 'For business', href: '/for-business' }
      // { name: 'API Documentation', href: '/api-documentation-page' },
      // { name: 'Shipping & Returns', href: '/shipping' }
    ]
  };
  
  // Social media links
  const socialLinks = [
    { name: 'Instagram', icon: 'Instagram', href: 'https://instagram.com/cosmelytix' },
    // { name: 'Twitter', icon: 'Twitter', href: 'https://twitter.com' },
    { name: 'Facebook', icon: 'Facebook', href: 'https://facebook.com/cosmelytix' },
    // { name: 'YouTube', icon: 'Youtube', href: 'https://youtube.com' },
    // { name: 'Pinterest', icon: 'PinIcon', href: 'https://pinterest.com' }
  ];
  
  // Render minimal footer
  if (variant === 'minimal') {
    return (
      <footer className={`bg-[#2D1735] border-t border-border py-6 ${className}`} {...props}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-['#E9A969']">
                <Icon name="Sparkles" size={20} className="mr-2" />
                <span className="font-display font-semibold text-lg">COSMELYTIX</span>
              </Link>
              <span className="ml-4 text-sm text-['#E9A969']">
                © {currentYear} COSMELYTIX. All rights reserved.
              </span>
            </div>
            
            <div className="mt-4 md:mt-0 flex space-x-6">
              {socialLinks.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-primary-light hover:text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.name}
                >
                  <Icon name={item.icon} size={20} />
                </a>
              ))}
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-border flex flex-wrap gap-x-8 gap-y-2">
            <Link to="/terms" className="text-sm text-primary hover:text-primary">
              Terms of Service
            </Link>
            <Link to="/privacy" className="text-sm text-primary hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/cookies" className="text-sm text-primary hover:text-primary">
              Cookie Policy
            </Link>
            <Link to="/accessibility" className="text-sm text-primary hover:text-primary">
              Accessibility
            </Link>
            <Link to="/api-documentation-page" className="text-sm text-primary hover:text-primary">
              API Documentation
            </Link>
          </div>
        </div>
      </footer>
    );
  }
  
  // Render full footer
  return (
    <footer className={`bg-[#2D1735] border-t border-border pt-12 pb-8 ${className}`} {...props}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-1">


<Link to="/" className="flex items-center">
      <div className="flex items-center text-primary">
        {/* Use AppImage for logos with different sources for different screen sizes */}
        <AppImage
          src="https://cosmelytix-brand-book-public.s3.us-east-1.amazonaws.com/brand_materials/cosmelytix_logo.svg"

          alt="Cosmelytix Logo"
          className="h-12 w-auto"
        />
      </div>
    </Link>

            <p className="mt-4 text-sm text-primary">
            Discover the best in beauty with AI-powered recommendations and our curated collection of cosmetics and skincare products.
            </p>
            <div className="mt-6 flex space-x-5">
              {socialLinks.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-primary hover:text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.name}
                >
                  <Icon name={item.icon} size={20} />
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-primary-light uppercase tracking-wider">Products</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.products.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-primary hover:text-primary">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-primary-light uppercase tracking-wider">Account</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.account.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-primary hover:text-primary">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-primary-light uppercase tracking-wider">Company</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.company.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-primary hover:text-primary">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-primary-light uppercase tracking-wider">Support</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.support.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-primary hover:text-primary">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <p className="text-sm text-primary">
             COSMELYTIX © {currentYear}. All rights reserved.
            </p>
            
            <div className="mt-4 md:mt-0 flex flex-wrap gap-x-8 gap-y-2">
              {footerNavigation.legal.map((item) => (
                <Link key={item.name} to={item.href} className="text-sm text-primary hover:text-primary">
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;